import { render } from "./StorageTableViewer.vue?vue&type=template&id=1a1521ff&scoped=true"
import script from "./StorageTableViewer.vue?vue&type=script&lang=js"
export * from "./StorageTableViewer.vue?vue&type=script&lang=js"

import "./StorageTableViewer.vue?vue&type=style&index=0&id=1a1521ff&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1521ff"]])

export default __exports__